import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { withLang } from "@/lib/i18n";

/**
 * Reusable Share button. Uses the Web Share API when available (mobile),
 * falls back to clipboard copy on desktop.
 */
const ShareButton = ({
  title = "Radon Action & Tracking",
  text = "Share this with someone who should know their radon level.",
  url,
  label = "Share this page",
  copiedLabel = "Copied!",
  variant = "primary",
}) => {
  const [copied, setCopied] = useState(false);
  const target = withLang(url || window.location.href);

  const onClick = async () => {
    try {
      if (typeof navigator !== "undefined" && navigator.share) {
        await navigator.share({ title, text, url: target });
        return;
      }
    } catch (_) {
      // user cancelled; fall through to clipboard copy
    }
    try {
      await navigator.clipboard.writeText(target);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (_) {
      // ignore
    }
  };

  const base =
    "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors";
  const styles =
    variant === "primary"
      ? "bg-[#2F524A] text-white hover:bg-[#243E38]"
      : "border border-[#2F524A] text-[#2F524A] hover:bg-[#F4F7F6]";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${base} ${styles}`}
      data-testid="share-page-button"
    >
      {copied ? <Check className="w-4 h-4" /> : <Share2 className="w-4 h-4" />}
      {copied ? copiedLabel : label}
    </button>
  );
};

export default ShareButton;
